<div class="modal-header">
  <h3 class="modal-title">
    {{ 'employeeModule.calendarChecked' | translate }}
  </h3>
</div>
<div class="modal-body">
  <div *ngIf="contracts?.length" class="mb-4">
    <label id="contractId" class="form-label">
      {{ 'employeeModule.selectYourContract' | translate }}
    </label>

    <custom-select
      [ariaLabelledby]="'contractId'"
      [selectableItems]="
        contracts$
          | async
          | mapToSelectableItemsPipe: 'id' : 'description' : 'simple'
      "
      [clearable]="true"
      [valueBinder]="'id'"
      [emptyInitValue]="true"
      [allowSelectNullValue]="false"
      [loading]="!(contracts$ | async).length"
      [(ngModel)]="selectedContractId"
      (ngModelChange)="onChangeContract()"
      [placeholder]="['']"
    ></custom-select>
  </div>

  <div *ngIf="currentCalendarCheckedDate" class="mb-4">
    <label class="form-label" id="calendarCheckedLabel">
      {{ 'employeeModule.currentCalendarCheckedDate' | translate }}
    </label>

    <datetime-input
      aria-labelledby="calendarCheckedLabel"
      [hideTime]="true"
      [isDisabled]="true"
      [(ngModel)]="currentCalendarCheckedDate"
    ></datetime-input>
  </div>

  <form [formGroup]="form" (ngSubmit)="onFormSubmit()">
    <div *ngIf="selectedContractId" class="mb-4">
      <label class="form-label" id="selectContractLabel">
        {{ 'employeeModule.newCalendarCheckedDate' | translate }}
      </label>

      <datetime-input
        aria-labelledby="electContractLabel"
        formControlName="calendarCheckedDate"
        aria-describedby="calendarCheckedDate calendarCheckedDate2"
        [hideTime]="true"
      ></datetime-input>
      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="calendarCheckedDate"
        role="alert"
        *ngIf="
          form.controls.calendarCheckedDate.dirty &&
          form.controls.calendarCheckedDate.invalid
        "
      >
        {{ 'general.value' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="calendarCheckedDate2"
        role="alert"
        *ngIf="calendarCheckedDateIsInPast"
      >
        {{ 'employeeModule.calendarCheckedDateIsInPast' | translate }}
      </p>
    </div>

    <div class="d-flex justify-content-between pt-3">
      <button class="btn btn-soft-primary" type="button" (click)="cancel()">
        {{ 'general.back' | translate }}
      </button>

      <button
        class="btn btn-primary"
        type="submit"
        [disabled]="calendarCheckedDateIsInPast"
      >
        {{ 'general.save' | translate }}
      </button>
    </div>
  </form>
</div>
